var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.576,
    height: 140,
    rx: 70,
    fill: "#F3E3E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_6123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1261 32.6243C79.5045 33.0605 79.354 33.918 79.7901 34.5396L86.8969 44.6705C87.333 45.2922 88.1905 45.4426 88.8122 45.0065C89.4338 44.5704 89.5843 43.7129 89.1482 43.0912L82.8311 34.086L91.8363 27.7689C92.458 27.3328 92.6084 26.4753 92.1723 25.8536C91.7362 25.2319 90.8787 25.0815 90.257 25.5176L80.1261 32.6243ZM114.041 70.625L115.411 70.7369L114.041 70.625ZM57.5439 95.3096C57.0245 94.7556 56.1544 94.7275 55.6004 95.2469C55.0463 95.7663 55.0183 96.6364 55.5377 97.1904L57.5439 95.3096ZM80.6782 35.1043C86.4361 36.1145 94.9775 39.1285 101.799 44.8358C108.573 50.5034 113.627 58.7916 112.67 70.5131L115.411 70.7369C116.454 57.9584 110.883 48.8507 103.564 42.7267C96.2915 36.6423 87.2704 33.4689 81.1534 32.3957L80.6782 35.1043ZM112.67 70.5131C111.46 85.3363 104.087 93.5676 96.8971 98.1363C93.281 100.434 89.6957 101.813 86.9377 102.615C85.5603 103.016 84.3957 103.272 83.5459 103.426C83.1209 103.503 82.7778 103.555 82.5291 103.586C82.2544 103.621 82.1482 103.625 82.1658 103.625V106.375C82.4579 106.375 83.1421 106.295 84.0376 106.132C84.9749 105.962 86.2322 105.685 87.7063 105.256C90.6515 104.398 94.4881 102.925 98.3719 100.457C106.182 95.4949 114.121 86.5387 115.411 70.7369L112.67 70.5131ZM82.1658 103.625C80.7301 103.625 66.4328 104.791 57.5439 95.3096L55.5377 97.1904C65.3988 107.709 81.1015 106.375 82.1658 106.375V103.625Z",
    fill: "#DD4F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5407 91.875C42.7907 81.25 37.0406 56.125 59.0406 40.625",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeDasharray: "5.5 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7908 48.125L77.5812 67.4663C78.3965 68.5325 79.9082 68.7646 81.0058 67.9922L95.9158 57.5",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_6123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.5758,
    height: 80,
    fill: "white",
    transform: "translate(40 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingTime);
export default __webpack_public_path__ + "static/media/saving-time.af4cb7646b60c5eb60b6f8ff1833c0bb.svg";
export { ForwardRef as ReactComponent };